import { jsxs, jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Badge from "../Badge/Badge.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import './Header.css';/* empty css            */
const HeaderCounterButton = ({
  count,
  icon,
  onClick,
  children
}) => {
  return /* @__PURE__ */ jsxs(
    Button,
    {
      type: "text",
      className: classnames("perxis-auto-header-counter-button"),
      icon: icon ? /* @__PURE__ */ jsx(Icon, { name: icon, className: classnames("perxis-auto-header-counter-button__icon") }) : null,
      directionalWrap: false,
      onClick,
      children: [
        /* @__PURE__ */ jsx("bdi", { children }),
        /* @__PURE__ */ jsx(Badge, { count, className: classnames("perxis-auto-header-counter-button__badge") })
      ]
    }
  );
};
export {
  HeaderCounterButton as default
};
//# sourceMappingURL=HeaderCounterButton.js.map
